import { Injectable } from '@angular/core';

export type TipoPortal = 'aluno' | 'professor' | 'familia';

interface Credenciais {
  nome: string;
  usuario: string;
  senha: string;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private professores: Credenciais[] = [
    { nome: 'REGIANE PINHEIRO', usuario: '27704303864', senha: '123456789' },
    { nome: 'ABIQUEILA DE PAULA', usuario: '25169677804', senha: '123456789' },
    {
      nome: 'PESSOA PROFESSOR DEMONSTRAÇÃO',
      usuario: '62173328093',
      senha: '123456789',
    },
  ];

  private alunos: Credenciais[] = [
    {
      nome: 'BRYAN NIDIALCOV ALVES DA SILVA',
      usuario: '4262712',
      senha: '4262712',
    },
    { nome: 'KEROLLYN DA SILVA BORGES', usuario: '4272171', senha: '4272171' },
    {
      nome: 'EMILLY VYTORIA CARVALHO TENORIO',
      usuario: '554077',
      senha: '554077',
    },
    { nome: 'ALYCE ISABELLY MARTINS SENA', usuario: '516693', senha: '516693' },
  ];

  private familias: Credenciais[] = [
    {
      nome: 'PAMELA DA SILVA CARVALHO',
      usuario: '37340631836',
      senha: '37340631836',
    },
    {
      nome: 'Rosires da Silva Xavier',
      usuario: '28688323852',
      senha: '28688323852',
    },
    { nome: 'avó demonstração', usuario: '90778382010', senha: '90778382010' },
  ];

  private readonly STORAGE_KEY = 'portalLogado';

  login(tipo: TipoPortal, usuario: string, senha: string): Credenciais | null {
    let lista: Credenciais[];
  
    switch (tipo) {
      case 'professor':
        lista = this.professores;
        break;
      case 'aluno':
        lista = this.alunos;
        break;
      case 'familia':
        lista = this.familias;
        break;
      default:
        return null;
    }
  
    const encontrado = lista.find(
      (cred) => cred.usuario === usuario && cred.senha === senha
    );
  
    if (encontrado) {
      localStorage.setItem('portalLogado', tipo);
      return encontrado;
    }
  
    return null;
  }  

  isLogado(): boolean {
    return !!this.getPortalLogado();
  }

  getPortalLogado(): TipoPortal | null {
    return localStorage.getItem(this.STORAGE_KEY) as TipoPortal | null;
  }

  logout(): void {
    localStorage.removeItem(this.STORAGE_KEY);
  }
}